module.exports = __webpack_public_path__ + "img/figure_2.16ba6395.svg";